export default "__VITE_ASSET__CUNacwBN__"